module.exports = __webpack_public_path__ + "img/tips.c569cb5a.svg";